var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-footer',{staticStyle:{"justify-content":"center","color":"#000000","text-align":"center"},attrs:{"id":"app-footer","color":"#E5E5E5"}},[_vm._v(_vm._s(_vm.$t("footerText", [new Date().getFullYear()])))])
}
var staticRenderFns = []

export { render, staticRenderFns }